export function usePanelAvatar() {
  const { logout } = useLogout();
  function logUserOut() {
    logout();
  }
  const menu = ref();
  const items = ref([
    {
      label: "Ustawienia",
      icon: "pi pi-cog",
      route: "/settings",
    },
    {
      label: "Wyloguj się",
      icon: "pi pi-sign-out",
      command: logUserOut,
    },
  ]);

  const toggle = (event: Event) => {
    menu.value.toggle(event);
  };

  return { menu, items, toggle };
}
